module.exports = {"ifsc":"RATN0VAAPIS","accountno":"2223330073645874","name":"Reliance Broadcast Network Limited"}


//////////////////
// WEBPACK FOOTER
// ./config/accdetails.json
// module id = 1607
// module chunks = 0